import { Pagination, Row, Select, Space } from "antd";
import useNotification from '@/hooks/notifications';
import { useEffect, useState } from "react";
import useFetchListData from "../../hooks/useFetchListData";
import HighlightedTable from '@Components/Tables/HighlightedTable';
import Search from "antd/es/input/Search";
import { highlightItemPost } from "../../utils/fetchFunctions/highlight";

const searchTypes = [
	{ label: 'Search by reference ID', value: 'topicKey' },
	{ label: 'Search by keywords', value: 'search' },
];

const orderTypes = [
	{ label: 'Relevancy', value: 'relevancy:asc' },
	{ label: 'Update Date: newest', value: 'modified:desc' },
	{ label: 'Update Date: oldest', value: 'modified:asc' },
];

export default function SpotlightedTopic({spotlightedTopic}) {
  const {openNotification} = useNotification();
  const [loadingChange, setLoadingChange] = useState(false);

  const params = {type: 'topics', sort: 'modified:desc', };
	const { data, loading, searchParams, setParam, setParams, getData, pagination, error } = useFetchListData({params, newFunctions: true});

  useEffect(() => {
    const err = spotlightedTopic.error || error;
		if (err) {
			openNotification({message: 'Something went wrong!', description: err.message || null, type: 'error'});
		}
	}, [spotlightedTopic.error, error]);

  function handlePagination(page, pageSize) {
		setParams({page, pageSize});
	}

  const handleSearch = () => {
		setParams({sort: 'modified:desc'});
	};

	async function select (id) {
		setLoadingChange(true);

		const res = await highlightItemPost({url: 'topics', id, name: 'spotlighted'});

		if (res.error) {
			openNotification({message: 'Something went wrong!', description: res.message || null, type: 'error'});
			setLoadingChange(false);
			return;
		}
    await Promise.all([getData(), spotlightedTopic.getData()]);
		setLoadingChange(false);
	}

	async function unselect (id) {
		setLoadingChange(true);
		const res = await highlightItemPost({url: 'topics', id, name: 'spotlighted', highlighted: false});

		if (res.error) {
			openNotification({message: 'Something went wrong!', description: res.message || null, type: 'error'});
			setLoadingChange(false);
			return;
		}

		await Promise.all([getData(), spotlightedTopic.getData()]);
		setLoadingChange(false);
	}
	return (
    <Space size="large" direction='vertical' style={{width: '100%'}} >
      <h2>Spotlighted Topic</h2>
      <HighlightedTable
				data={spotlightedTopic.data}
				loading={spotlightedTopic.loading || loadingChange}
				getListData={spotlightedTopic.getData}
				type="topic"
				select={select}
				unselect={unselect}
				updateDate
        selectedKey="spotlighted"
			/>
      <h2>All Topics</h2>
      <Search
				addonBefore={
					<Select
						style={{width: 190}}
						options={searchTypes}
						value={searchParams.get("searchType") || 'search'}
						onChange={setParam('searchType')}
					/>
				}
				value={searchParams.get("search") || ''}
				onChange={setParam('search', false)}
				onSearch={handleSearch}
				enterButton
			/>
      <HighlightedTable
				data={ data }
				loading={loading || loadingChange}
				sort={searchParams.get("sort") || 'modified:desc'}
				setSort={setParam('sort')}
				getListData={getData}
				type="topic"
				select={select}
				unselect={unselect}
				updateDate
        selectedKey="spotlighted"
        orderTypes={orderTypes}
			/>
      <Row justify="center">
					<Pagination
						total={pagination.totalElements}
						pageSize={pagination.pageSize}
						current={pagination.page}
						showSizeChanger
						showQuickJumper
						hideOnSinglePage
						disabled={loading}
						onChange={handlePagination}
					/>
				</Row>
    </Space>

  );
}